import { webInitiation } from 'common/constants/permissions';

const canWebInitiationNotification = permissions => !!permissions[webInitiation];

export default {
    canWebInitiationNotification
};
